import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const AddComponent = ({ apiEndpoint, onSuccess, onClose, title = "Add New Project" }) => {
  const [formData, setFormData] = useState({
    ProjectName: "",
    LocationID: "",
    ProjectIncharge: "",
    StageID: "",
    MailID: "",
  });

  const [dropdowns, setDropdowns] = useState({
    locations: [],
    users: [],
    stages: [],
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const enteredBy = useSelector((state) => state.auth.username);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [locations, users, stages] = await Promise.all([
          axios.get(`${API_BASE_URL}/dropdown/locations`),
          axios.get(`${API_BASE_URL}/dropdown/users`),
          axios.get(`${API_BASE_URL}/dropdown/stages`),
        ]);
        setDropdowns({
          locations: locations.data,
          users: users.data,
          stages: stages.data,
        });
      } catch (err) {
        setError("Failed to fetch dropdown data.");
      }
    };
    fetchDropdownData();
  }, [API_BASE_URL]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await axios.post(apiEndpoint, { ...formData, EnteredBy: enteredBy });
      if (onSuccess) {
        await onSuccess();
      }
      if (onClose) {
        onClose();
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add project.");
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow-md max-w-md mx-auto">
      <h2 className="text-lg font-semibold mb-4">{title}</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <input
            type="text"
            name="ProjectName"
            value={formData.ProjectName}
            onChange={handleChange}
            placeholder="Project Name"
            className="w-full border rounded px-4 py-2"
            required
          />
        </div>
        <div>
          <select
            name="LocationID"
            value={formData.LocationID}
            onChange={handleChange}
            className="w-full border rounded px-4 py-2"
            required
          >
            <option value="">Select Location</option>
            {dropdowns.locations.map((loc) => (
              <option key={loc.LocationID} value={loc.LocationID}>
                {loc.LocationName}
              </option>
            ))}
          </select>
        </div>
        <div>
          <select
            name="ProjectIncharge"
            value={formData.ProjectIncharge}
            onChange={handleChange}
            className="w-full border rounded px-4 py-2"
            required
          >
            <option value="">Select Project Incharge</option>
            {dropdowns.users.map((user) => (
              <option key={user.UserID} value={user.Username}>
                {user.Username}
              </option>
            ))}
          </select>
        </div>
        <div>
          <select
            name="StageID"
            value={formData.StageID}
            onChange={handleChange}
            className="w-full border rounded px-4 py-2"
            required
          >
            <option value="">Select Stage</option>
            {dropdowns.stages.map((stage) => (
              <option key={stage.StageID} value={stage.StageID}>
                {stage.StageName}
              </option>
            ))}
          </select>
        </div>
        <div>
          <input
            type="email"
            name="MailID"
            value={formData.MailID}
            onChange={handleChange}
            placeholder="Mail ID"
            className="w-full border rounded px-4 py-2"
            required
          />
        </div>
        <div className="flex gap-4 justify-end pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            disabled={loading}
          >
            {loading ? "Adding..." : "Add"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddComponent;